import { render, staticRenderFns } from "./Downloadp.vue?vue&type=template&id=07f8c8a6&"
import script from "./Downloadp.vue?vue&type=script&lang=js&"
export * from "./Downloadp.vue?vue&type=script&lang=js&"
import style0 from "./Downloadp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports